import { HomePageActionBase } from "./home-page-base-action";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { IHomePageAction } from "./i-home-page-action";
import { FormInstance } from "../../../models/site-content/form-instance.model";

export class MoveFormsAction extends HomePageActionBase implements IHomePageAction {
    public getTitle(): string {
        return "Move Form(s)";
    }

    public permissionsRequiredToPerform(): string {
        return "CanCreateForm"
    }

    public requiresTree(): boolean {
        return true;
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        let targetFolderId = paramObj.folderId;

        this.message = "Moving selected Form(s)...";
        let formInstanceIds: number[] = this.formInstanceGridRows.map(x => { return x.Id });
        return this.folderService.moveFormInstances(formInstanceIds, targetFolderId).then(x => {
            return new HomePageActionDialogReturnObj();
        });
    }
}
